module.exports = __webpack_public_path__ + "media/img/event/Virtual-Scholarship-Fair-2020-Feature-Layer-01-daf7ab8df0bf02c53d357a41ffa1b272.svg";